// core version + navigation, pagination modules:
import Swiper, { Navigation } from 'swiper';
// swiper core styles
import 'swiper/css';

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            let wrapper = node.querySelector('.swiper'),
                prevBtn = node.querySelector('.logos-swiper--prev'),
                nextBtn = node.querySelector('.logos-swiper--next');
            new Swiper(wrapper, {
                // Optional parameters
                modules: [Navigation],
                slidesPerView: 1,
                centeredSlides: false,
                loop: true,
                spaceBetween: 20,
                breakpoints: {
                    // when window width is >= '400px'
                    400: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    // when window width is >= 'md'
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    // when window width is >= 'lg'
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
                    // when window width is >= 'xl'
                    1200: {
                        slidesPerView: 5,
                        spaceBetween: 20,
                    }
                },
                // Navigation buttons
                navigation: {
                    prevEl: prevBtn,
                    nextEl: nextBtn
                },
            });
        }
    });
}
